// src/RiskSourcePicker.jsx
import { FormControl, Select, MenuItem, Chip, InputLabel, Box, TextField } from '@mui/material';

export default function RiskSourcePicker({ label, type = 'multiselect', options = [], selected = [], onChange, toTitleCase }) {
  console.log('🔍 [RiskSourcePicker]', { label, type, options, selected });
  return (
    <FormControl fullWidth margin="normal">
      <InputLabel shrink>{toTitleCase(label)}</InputLabel>

      {type === 'text' ? (
        <TextField
          fullWidth
          placeholder="Type here…"
          value={selected || ''}
          onChange={e => onChange({ target: { value: e.target.value } })}
          multiline
          minRows={2}
          sx={{ mt: 2 }}
        />
      ) : (
        <Select
          multiple
          label={toTitleCase(label)}
          value={selected}
          onChange={onChange}
          renderValue={(sel) => (
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
              {sel.map(v => (
                <Chip key={v} label={v} />
              ))}
            </Box>
          )}
        >
          {options.map(o => (
            <MenuItem key={o} value={o}>
              {o}
            </MenuItem>
          ))}
        </Select>
      )}
    </FormControl>
  );
}